module.exports = __webpack_public_path__ + "img/noc-dashboard-thumbnail.da511925.jpg";